import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { Card } from 'src/components/card';
import { Picture } from 'src/components/picture';
import { breakpointTablet } from 'src/styles/breakpoints';
import { fontPrimary } from 'src/styles/fonts';
import { spacing1, spacing2, spacing3 } from 'src/styles/spacing';

export const StyledModellAImage = styled(Picture)`
  display: none;

  @media (min-width: ${breakpointTablet}) {
    max-width: 170px;
    padding-bottom: ${spacing3};
    display: block;
    margin: 0 auto;
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpointTablet}) {
    min-height: 346px;
    padding-bottom: ${spacing1};
  }
`;

export const StyledDescription = styled(Typography)`
  margin-bottom: ${spacing2};

  &:last-child {
    margin-bottom: ${spacing3};
  }

  @media (min-width: ${breakpointTablet}) {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  margin-bottom: ${spacing2};
  text-align: center;
  font-family: ${fontPrimary};

  @media (min-width: ${breakpointTablet}) {
    margin-bottom: ${spacing3};
  }
`;

export const StyledCard = styled(Card)`
  margin-bottom: ${spacing2};
`;
